<!-- 做菜時間 -->
<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('CookTime.title')"
			left-arrow
			fixed
			z-index=9
		  	@click-left="$router.go(-1)">
		</van-nav-bar> 
		<div class="contentWrapper">
			<van-cell-group>
				<span class="text">{{$t('CookTime.text1')}}</span>
				<van-field
					class="inputAr"
					readonly  	
					right-icon="arrow" 	  	
					@click="showStartTimePicker = true" 	
					:value='cook.startTime'
				/> 
				<!-- 弹框 -->
				<van-popup v-model="showStartTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentDate"
						type="date"
						:max-date="maxDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showStartTimePicker = false"
						@change="changeStartTime()"
						@confirm="onStartChangeConfirm"
					/>
				</van-popup>

				<span class="text">{{$t('CookTime.text')}}</span>
				<van-field
					class="inputAr"
					readonly
					right-icon="arrow" 		
					@click="showEndTimePicker = true"
					:value='cook.endTime'
				/>  
				<!-- 弹框 -->
				<van-popup v-model="showEndTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentEndDate"
						type="date"
						:min-date="minDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showEndTimePicker = false"
						@change="changeEndTime()"
						@confirm="onChangeConfirm"
					/>
				</van-popup>
			</van-cell-group>
			<div class="divideLine"></div>
			<van-tabs v-model="active" @click=onCookTime>
				<van-tab :title="$t('CookTime.longTime')">
					<!-- 表头 最长时间-->
					<van-cell :title="$t('CookTime.name')" :value="$t('CookTime.time')" class='title'></van-cell>
					<template v-for='(item,index) in cookTimeList'>
						<van-cell :title=item.name :value=item.slow_time v-if="item.name!==null"></van-cell>
					</template>
				</van-tab>
				<van-tab :title="$t('CookTime.averageTime')">
					<!-- 表头 平均时间-->
					<van-cell :title="$t('CookTime.name')" :value="$t('CookTime.time')" class='title'></van-cell>
					<template v-for='(item,index) in cookTimeList'>
						<van-cell :title=item.name :value=item.averages v-if="item.name!==null"></van-cell>
					</template>
				</van-tab>
				<van-tab :title="$t('CookTime.shortTime')">
					<!-- 表头 最短时间-->
					<van-cell :title="$t('CookTime.name')" :value="$t('CookTime.time')" class='title'></van-cell>
					<template v-for='(item,index) in cookTimeList'>
						<van-cell :title=item.name :value=item.fast_time v-if="item.name!==null"></van-cell>
					</template>
				</van-tab>
			</van-tabs>
		</div>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				active: 0,
  				cook:{
  					startTime:this.formatDateYMD1(new Date()),
  					endTime:this.formatDateYMD(new Date())
  				},
  				maxDate:new Date(),
  				minDate:new Date(),
  				currentDate:new Date(),
  				currentEndDate:new Date(),
  				showStartTimePicker:false,
  				showEndTimePicker:false,
  				cookTimeList:[],
  				fast_time:'fast_time', //最长
  				slow_time:'slow_time', //最短
  				averages:'averages'
  			}
  		},
  		mounted:function(){
  			// this.cook.startTime=this.formatDateYMD(new Date());
  			// this.cook.endTime=this.formatDateYMD(new Date());
  			this.getCookDate(this.fast_time);
	    },
	    methods:{
	    	getCookDate(Type){
	    		this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/menuServed',
	                data:{
	                	startday:this.cook.startTime,
	                	endday:this.cook.endTime,
	                	type:Type
	                }
	            }).then(res => {
					console.log(res);
	            	if(res.data.status==200){
	                	this.cookTimeList=res.data.data;
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
	    	onChangeConfirm(){
				this.cook.endTime=this.formatDateYMD(this.currentEndDate);
	    		this.showEndTimePicker = false;
	    		this.changeStatus();
	    	},
	    	onStartChangeConfirm(){
	    		this.cook.startTime=this.formatDateYMD(this.currentDate);
	    		this.showStartTimePicker = false;
	    		this.changeStatus();
	    	},
	    	//开始时间显示前一个月
	    	formatDateYMD1(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear();
			        var M = (date.getMonth()+1);
			        var D = date.getDate();

			        //获取前一个月的日期
			        var Y2=Y;
			        var M2=parseInt(M) - 1;
			        //如果月为0则显示去年最后一个月12月
			        if(M2==0){
			        	Y2 = parseInt(Y2) - 1;
        				M2 = 12;
			        }
			        var D2=D;
			        var DS2=new Date(Y2, M2, 0); 
			        DS2=DS2.getDate(); 
			        if(D2>DS2){
			        	D2=DS2
			        }
			        if(M2<10){
			        	M2=M2;
			        }
			        var t2=Y2 + '/' + M2 + '/' + D2;
			        return t2;
			    }
			},
	    	formatDateYMD(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear()+'/';
			        var M = (date.getMonth()+1)+ '/';
			        var D = date.getDate();
			        return Y+M+D;
			    }
			},
			changeStartTime(){
				this.cook.startTime=this.formatDateYMD(this.currentDate);
				this.minDate=this.currentDate;
			},
			changeEndTime(){
				this.cook.endTime=this.formatDateYMD(this.currentEndDate);
				this.maxDate=this.currentEndDate;
			},
			onCookTime(name,title){
				if(title == this.$t('CookTime.longTime')){ //最長時間
					this.getCookDate(this.fast_time);
				}else if(title == this.$t('CookTime.averageTime')){
					this.getCookDate(this.averages);
				}else{
					this.getCookDate(this.slow_time); //最短	
				}
			},
			changeStatus(){
				if(this.active==0){
	    			this.getCookDate(this.fast_time);
	    		}else if(this.active==1){
	    			this.getCookDate(this.averages);
	    		}else{
	    			this.getCookDate(this.slow_time);
	    		}
			}
	    }
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell{
		line-height: 24px;
	}
	/deep/ .van-cell__title{
		white-space: nowrap;
        /*设置内容不换行*/
        text-overflow: ellipsis;
        /*设置文字超出文本框的内容显示成...*/
        overflow: hidden;
        /*设置超出隐藏*/
	}
	/deep/ .van-tabs__line{
		background-color: #fd3f3f;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color: #2f75f7;
	}
	/deep/ .van-field__right-icon{
		margin-right:-10px;
		padding:0 5px;
	}
	.contentWrapper{
		/* padding-top: 46px; */
	}
	/*分割线*/
	.divideLine{
		height: 5px;
		background: #F3F5F7;
	}
	.van-row{
		text-align: center;
	}
	.van-cell-group{
		padding: 15px;
		display: flex;
		justify-content: space-between;
	}
	.inputAr{
		width: 40%;
		/*height: 35px;*/
		line-height: 15px;
		border: 2px solid #000;
		border-radius: 50px;
		font-size: 14px;
	}
	/* 至 */
	.text{
		line-height: 35px
	}
	.title{
		font-size: 14px;
		color: #444;
	}
</style> -->


// WEBPACK FOOTER //
// src/Report/CookTime.vue